/**
 * Returns the button text to be displayed in details page
 *
 * @param contentEntitlement Content entitlement
 * @param isLoggedIn User logged status
 * @param freePreviewAvailable content free preview availability
 * @param isSubscribed User premium subscription
 * @param contentType Content Type
 * @param freeFirstEpisode First episode of series is free
 * @returns Text to display in details page button.
 */

import { ResourceVm } from 'qp-ui-interface';
import { VODDetailsMessage } from '../services/evergent/entitlement/model/entitlement/vod-details.message';
import { LocalStorageService } from '../services/storage/local-storage.service';

const START_WATCHING = 'Start Watching';
const UPGRADE_GOLD = 'UpgradeGold';
const PREVIEW = 'Preview';
const SUBSCRIBE = 'Subscribe';
const RENT = 'Rent';

export const getDetailsButton = (
  contentEntitlement: string,
  isLoggedIn: boolean,
  freePreviewAvailable: boolean,
  isSubscribed: boolean,
  contentType: string,
  resource: ResourceVm,
  localStorage?: LocalStorageService,
  freeFirstEpisode?: boolean
): string => {
  resource.isPurchased = getIsPurchased(resource, localStorage);
  if (resource?.isTvod && !resource?.isPurchased) {
    return RENT;
  }

  if (
    canPlayTvod(resource?.isTvod, resource?.isPurchased) ||
    contentEntitlement === 'Free' ||
    isSubscribed ||
    (contentType === 'webseries' && freeFirstEpisode)
  ) {
    return START_WATCHING;
  }

  // Variables for validation
  const status = localStorage.getItem('status');
  const subscription = localStorage.getItem('subscription') === 'free';
  const subscriptionStatus =
    localStorage.getItem('subscriptionStatus') === 'true';

  if (isLoggedIn) {
    // Check if user has to Upgrade to gold plan
    if (
      subscription &&
      subscriptionStatus &&
      !status?.toLocaleLowerCase()?.includes('final')
    ) {
      if (
        (contentType === 'webseries' && !freeFirstEpisode) ||
        contentType !== 'webseries'
      ) {
        return UPGRADE_GOLD;
      }
    }
  }

  if (freePreviewAvailable && !subscriptionStatus) {
    return PREVIEW;
  }

  return SUBSCRIBE;
};

export const getTvodContentPurchasedDetails = (
  resourceVm: ResourceVm,
  localStorage: LocalStorageService
) => {
  const tvodPurchasedList = JSON.parse(
    localStorage.getItem('tvodPurchasedList')
  );
  const purchasedDetail: VODDetailsMessage[] | null = tvodPurchasedList?.filter(
    (tvodPurchased: VODDetailsMessage) => {
      return tvodPurchased?.serviceID === resourceVm?.id;
    }
  );
  return purchasedDetail;
};

export const getIsPurchased = (
  resourceVm: ResourceVm,
  localStorage: LocalStorageService
) => {
  const purchasedTVOD = getTvodContentPurchasedDetails(
    resourceVm,
    localStorage
  );
  return purchasedTVOD?.length > 0 ? true : false;
};

/**
 * Check if the user can play the tvod content
 *
 * @returns
 */

export const canPlayTvod = (isTvod: boolean, isPurchased: boolean): boolean => {
  if (isTvod && isPurchased) {
    return true;
  } else {
    return false;
  }
};
